import React from 'react'
import PropTypes from "prop-types"
import BookSettingsLayout from "./BookSettingsLayout"


const BookSettings = ({tableIds,isBatch=false}) => {
    return (
        <div>
            <BookSettingsLayout tableIds={tableIds} isBatch={isBatch}></BookSettingsLayout>
        </div>
    )
}

BookSettings.propTypes = {
    tableIds: PropTypes.arrayOf(PropTypes.number).isRequired,
    isBatch:PropTypes.bool
}

export default BookSettings


// WEBPACK FOOTER //
// ./src/containers/ClubTable/component/bookSettings/BookSettings.js